export default "/img/YE.3841382a5428d1896a60693c96750700.png";